import otherFilters from './other/';

export default {
  install: (Vue) => {
    for (let key in otherFilters) {
      Vue.filter(key, otherFilters[key]);
    }
  },
};
